import {
  IEhicAanvragenEndpointClient,
  EhicAanvragenEndpointClient,
  SchengenverklaringOpsturenEndpointClient,
  ISchengenverklaringOpsturenEndpointClient,
  DocumentS1OpsturenEndpointClient,
  IDocumentS1OpsturenEndpointClient
} from "./OpenCak.Client.Generated";
import axios, { AxiosInstance } from "axios";

export class ClientFactory {
  private readonly baseUrl: string;
  private readonly instance?: AxiosInstance;

  constructor(apiUrl) {
    this.baseUrl = apiUrl;
    this.instance = axios;
  }

  getEhicAanvragenClient = (): IEhicAanvragenEndpointClient => {
    return new EhicAanvragenEndpointClient(this.baseUrl, this.instance);
  };

  getSchengenverklaringOpsturenClient = (): ISchengenverklaringOpsturenEndpointClient => {
    return new SchengenverklaringOpsturenEndpointClient(this.baseUrl, this.instance);
  };

  getDocumentS1OpsturenClient = (): IDocumentS1OpsturenEndpointClient => {
    return new DocumentS1OpsturenEndpointClient(this.baseUrl, this.instance);
  }
}
